import { styled } from "@acko-tech/building-blocks.ui.common";
export const SuperContainer = styled.div`
  background: #000;
  width: 100%;
`;

export const Container = styled.div`
  color: white;
  position: relative;
  overflow: hidden;
  margin: 0 auto;

  @media (max-width: 768px) {
    margin: 0;
    ${(props: { mStyles: any }) => props.mStyles}
  }

  ${(props: { styles: any }) => props.styles}
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
`;

export const HeaderText = styled.div`
  color: var(--background-white-n-0, #fff);
  text-align: center;

  font-family: "Euclid Circular B";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  padding: 0 2rem;

  @media (max-width: 768px) {
    line-height: 22px;
  }
`;

export const CarouselContainer = styled.div`
  margin-bottom: 40px;
  overflow: hidden;
  margin-bottom: 20px;
  margin: 0 0 32px 20px;
  @media (min-width: 768px) {
    margin: 0 0 32px 2rem;
  }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-snap-type: x mandatory;

  @media (min-width: 769px) {
    gap: 20px;
    scroll-snap-type: none;
    justify-content: flex-start;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CarCard = styled.div`
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  scroll-snap-align: start;
  border-radius: 12px;
  border: 1px solid #c1c1c1;
  background: #c1c1c1;

  @media (max-width: 768px) {
    border-radius: 10px;
  }
`;

export const CarImageContainer = styled.div<{ backgroundImage?: string }>`
  height: 234px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  position: relative;
  ${(props) =>
    props.backgroundImage
      ? `
    background-image: url(${props.backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `
      : `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  `}
  @media (max-width: 768px) {
  }

  @media (min-width: 769px) {
    height: 180px;
  }
`;

export const CarDetails = styled.div`
  padding: 24px 20px;
  background: rgba(0, 0, 0, 0.85);

  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`;

export const CarName = styled.div`
  color: var(--Text-White, #fff);
  font-family: "Euclid Circular B";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;

export const LocationText = styled.p`
  color: var(--Text-Disabled-grey200, #a6a6a6);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 8px 0 4px 0;
`;

export const PriceContainer = styled.div``;

export const Price = styled.span`
  color: var(--Text-White, #fff);

  /* Label/Small */
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const SavingsText = styled.span<{ brandColor?: string }>`
  color: var(--Green-G200, #8ce99a);

  /* Label/X Small */
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const NavigationDots = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
    margin-left: 20px;
  }
`;

export const Dot = styled.button<{ active: boolean }>`
  width: ${(props) => (props.active ? "32px" : "8px")};
  height: 6px;
  border: none;
  background-color: ${(props) =>
    props.active ? "#ffffff" : "rgba(255, 255, 255, 0.4)"};
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 16px;
  &:hover {
    background-color: ${(props) =>
      props.active ? "#ffffff" : "rgba(255, 255, 255, 0.6)"};
  }
`;

export const ExploreButton = styled.button`
  background: #0fa457;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 16px 32px;
  color: #ffffff;
  font-family: "Euclid Circular B", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0px;
  gap: 8px;
  width: calc(100% - 40px);
  margin: 20px auto;
  height:48px;
  @media (min-width: 768px) {
    width: calc(100% - 64px);
    margin: 32px auto;
  }

  &:hover {
    background: #0fa457;
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:active {
    transform: translateY(1px);
  }
`;
export const GetACallBackButton = styled.button`
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 16px 32px;
  color: #ffffff;
  font-family: "Euclid Circular B", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0px;
  gap: 8px;
  width: calc(100% - 40px);
  margin: 20px auto;
  height:48px;
  @media (min-width: 768px) {
    width: calc(100% - 64px);
    margin: 32px auto;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:active {
    transform: translateY(1px);
  }
`;
